import { useAuth } from "./AuthContext";
import { Box, Typography, Button } from "@mui/material";

const Dashboard = () => {
  const { logout, user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h4" sx={{ color: "#ff6600", mb: 2 }}>
        Welcome to the Dashboard
      </Typography>
      <Typography sx={{ mb: 4, textAlign: "center" }}>
        You’re successfully logged in.
      </Typography>
      <Box sx={{ mb: 2 }}>
      {/* Bullet library button */}
      <Button
        variant="outlined"
        href="/"
        sx={{
          borderColor: "#ff6600",
          color: "#ff6600",
          '&:hover': {
            backgroundColor: "#ff6600",
            color: "#000",
          }
        }}
      >
        Bullet Library
      </Button>
      {/* Change password button */}
      <Button
        variant="outlined"
        href="/change-password"
        sx={{
          borderColor: "#ff6600",
          color: "#ff6600",
          '&:hover': {
            backgroundColor: "#ff6600",
            color: "#000",
          },
          margin: "0 8px"
        }}
      >
        Change Password
      </Button>

      {user?.isAdmin && (
        <Button
          variant="outlined"
          href="/users"
          sx={{
            borderColor: "#ff6600",
            color: "#ff6600",
            '&:hover': {
              backgroundColor: "#ff6600",
              color: "#000",
            },
            margin: "0 8px 0 0"
          }}
        >
          Users
        </Button>
      )}

      {/* Logout button */}
      <Button
        variant="outlined"
        onClick={logout}
        sx={{
          borderColor: "#ff6600",
          color: "#ff6600",
          '&:hover': {
            backgroundColor: "#ff6600",
            color: "#000",
          },
        }}
      >
        Logout
      </Button>
      </Box>
    </Box>
  );
};

export default Dashboard;
